import { Grid, Typography } from '@material-ui/core'
import React from 'react'
import CustomViewForm from '../../CustomViewForm'
import Loader from '../../Loader'
import ViewPdf from '../../ViewPdf'

function ProductCatalougeView({ productCatalouge }) {
  const data = [
    { label: 'Name', data: productCatalouge.name },
    { label: 'Description', data: productCatalouge.description },
    { label: 'Files', data: productCatalouge.image.map((item) => <ViewPdf image={item} />) },
    // { label: 'File', data: 'Dummy' },
  ]
  return (
    // <Grid container>
    //   <Grid item lg={12} container spacing={3}>
    //     {data.map((item, index) => (
    //       <Grid item lg={4} key={index}>
    //         <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
    //           <Typography style={{ fontSize: '16px', fontWeight: 600 }}>{item.label}</Typography>
    //           {item.label === 'File' ? (
    //             //   <img src={item.data} alt="catgeory" width="50%" />
    //             <Typography style={{ fontSize: '14px', fontWeight: 400 }}>{item.data}</Typography>
    //           ) : (
    //             <Typography style={{ fontSize: '14px', fontWeight: 400 }}>{item.data}</Typography>
    //           )}
    //         </div>
    //       </Grid>
    //     ))}
    //   </Grid>
    // </Grid>
    <CustomViewForm data={data} />
  )
}

export default ProductCatalougeView
